// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CreateMissingMemberPortalAccessPopup-module__content___C4yJn {
  padding: 20px 30px 5px;
}

.CreateMissingMemberPortalAccessPopup-module__description___yiywO {
  margin-bottom: 16px;
}

.CreateMissingMemberPortalAccessPopup-module__buttonsContainer___o46q8 {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding: 0 30px 24px;
}`, "",{"version":3,"sources":["webpack://./src/popups/CreateMissingMemberPortalAccessPopup/CreateMissingMemberPortalAccessPopup.module.scss"],"names":[],"mappings":"AAAA;EACE,sBAAA;AACF;;AAEA;EACE,mBAAA;AACF;;AAEA;EACE,aAAA;EACA,yBAAA;EACA,SAAA;EACA,oBAAA;AACF","sourcesContent":[".content {\n  padding: 20px 30px 5px;\n}\n\n.description {\n  margin-bottom: 16px;\n}\n\n.buttonsContainer {\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n  padding: 0 30px 24px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"content": `CreateMissingMemberPortalAccessPopup-module__content___C4yJn`,
	"description": `CreateMissingMemberPortalAccessPopup-module__description___yiywO`,
	"buttonsContainer": `CreateMissingMemberPortalAccessPopup-module__buttonsContainer___o46q8`
};
module.exports = ___CSS_LOADER_EXPORT___;
